/* ===========================================================================
   Modal
   =========================================================================== */

const $modal = $('#js-reveal');

/**
* Description for modalAjax
* @private
* @method modalAjax
* @param {Object} $elem
* @return {Object} description
*/
export function modalAjax(url) {

  $.ajax(url).done((resp) => {
    $modal.html(resp).foundation('open');
  });

}
